import { FC } from 'react';

import { RequiredRule } from 'devextreme-react/form';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import { MONEY_FORMAT } from 'constants/formats';
import { DateBox, NumberBox, TextArea, Validator } from 'devextreme-react';

import { DriverPumpSalaryItemCreate } from 'bus/driverPumpMixerSalary/types';

type Props = {
  form: DriverPumpSalaryItemCreate;
  onChange: (
    name: keyof DriverPumpSalaryItemCreate,
    value: DriverPumpSalaryItemCreate[keyof DriverPumpSalaryItemCreate],
  ) => void;
};

export const PumpSalaryForm: FC<Props> = ({ form, onChange }) => {
  return (
    <AppRow className="mt-2">
      <AppGroup col={6}>
        <AppFiledBox label="Дата начала" labelTop>
          <DateBox
            stylingMode="underlined"
            type="date"
            onValueChange={(e) => {
              onChange('dateBegin', e as string);
            }}
            useMaskBehavior
            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
            value={form.dateBegin}
          >
            <Validator>
              <RequiredRule message="Заполните поле дата начала" />
            </Validator>
          </DateBox>
        </AppFiledBox>

        <AppFiledBox label="Длина насоса" labelTop>
          <NumberBox
            stylingMode="underlined"
            value={form.pumpLen || undefined}
            onValueChange={(e) => {
              onChange('pumpLen', e);
            }}
          >
            <Validator>
              <RequiredRule message="Заполните поле длина насоса" />
            </Validator>
          </NumberBox>
        </AppFiledBox>

        <AppFiledBox label="Цена за 1км" labelTop>
          <NumberBox
            stylingMode="underlined"
            value={form.price || undefined}
            onValueChange={(e) => {
              onChange('price', e);
            }}
            format={MONEY_FORMAT}
          >
            <Validator>
              <RequiredRule message="Заполните поле цена" />
            </Validator>
          </NumberBox>
        </AppFiledBox>

        <AppGroup title="Оплата водителям">
          <AppRow>
            <AppFiledBox label="Минимальная цена" labelTop>
              <NumberBox
                stylingMode="underlined"
                value={form.minimalPumpDriverPrice ?? undefined}
                onValueChange={(e) => {
                  onChange('minimalPumpDriverPrice', e || 0);
                }}
              />
            </AppFiledBox>
            <AppFiledBox label="От кубов" labelTop>
              <NumberBox
                stylingMode="underlined"
                value={form.minimalPumpQuantity ?? undefined}
                onValueChange={(e) => {
                  onChange('minimalPumpQuantity', e || 0);
                }}
              />
            </AppFiledBox>
            <AppFiledBox label="Цена за куб" labelTop>
              <NumberBox
                stylingMode="underlined"
                value={form.pumpDriverOverPrice ?? undefined}
                onValueChange={(e) => {
                  onChange('pumpDriverOverPrice', e || 0);
                }}
              />
            </AppFiledBox>
          </AppRow>
        </AppGroup>
      </AppGroup>

      <AppGroup col={6}>
        <AppFiledBox label="Трубы %" labelTop>
          <NumberBox
            stylingMode="underlined"
            value={form.pumpPipes ?? undefined}
            format="fixedPoint"
            onValueChange={(e) => {
              onChange('pumpPipes', e || 0);
            }}
            max={100}
          >
            <Validator>
              <RequiredRule message="Заполните поле трубы" />
            </Validator>
          </NumberBox>
        </AppFiledBox>

        <AppFiledBox label="Переезд %" labelTop>
          <NumberBox
            stylingMode="underlined"
            value={form.pumpMoving ?? undefined}
            format="fixedPoint"
            onValueChange={(e) => {
              onChange('pumpMoving', e || 0);
            }}
            max={100}
          >
            <Validator>
              <RequiredRule message="Заполните поле переезд %" />
            </Validator>
          </NumberBox>
        </AppFiledBox>

        <AppFiledBox label="Простой %" labelTop>
          <NumberBox
            stylingMode="underlined"
            value={form.downtime ?? undefined}
            onValueChange={(e) => {
              onChange('downtime', e || 0);
            }}
            max={100}
          >
            <Validator>
              <RequiredRule message="Заполните поле простой %" />
            </Validator>
          </NumberBox>
        </AppFiledBox>

        <AppFiledBox label="Гаситель, руб" labelTop>
          <NumberBox
            stylingMode="underlined"
            value={form.pumpQuencher ?? undefined}
            onValueChange={(e) => {
              onChange('pumpQuencher', e || 0);
            }}
            format={MONEY_FORMAT}
          >
            <Validator>
              <RequiredRule message="Заполните поле гаситель" />
            </Validator>
          </NumberBox>
        </AppFiledBox>

        <AppFiledBox label="Комментарий" labelTop>
          <TextArea
            stylingMode="underlined"
            value={form.comment}
            onValueChange={(e) => {
              onChange('comment', e);
            }}
            height={90}
          />
        </AppFiledBox>
      </AppGroup>
    </AppRow>
  );
};
